/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { CmsEditingUser } from '../model/cmsEditingUser';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class CMSUsersService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Delete a user
   * @param user_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsDeleteUser2(
    user_id: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public cmsDeleteUser2(
    user_id: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public cmsDeleteUser2(
    user_id: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public cmsDeleteUser2(
    user_id: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (user_id === null || user_id === undefined) {
      throw new Error(
        'Required parameter user_id was null or undefined when calling cmsDeleteUser2.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>(
      'delete',
      `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Get user
   * @param user_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsGetUser2(
    user_id: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingUser>;
  public cmsGetUser2(
    user_id: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingUser>>;
  public cmsGetUser2(
    user_id: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingUser>>;
  public cmsGetUser2(
    user_id: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (user_id === null || user_id === undefined) {
      throw new Error(
        'Required parameter user_id was null or undefined when calling cmsGetUser2.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<CmsEditingUser>(
      'get',
      `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Post new user
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsPostUser2(
    body?: CmsEditingUser,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingUser>;
  public cmsPostUser2(
    body?: CmsEditingUser,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingUser>>;
  public cmsPostUser2(
    body?: CmsEditingUser,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingUser>>;
  public cmsPostUser2(
    body?: CmsEditingUser,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<CmsEditingUser>(
      'post',
      `${this.basePath}/cms/user`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Update an existing user
   * @param user_id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsPutUser2(
    user_id: number,
    body?: CmsEditingUser,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingUser>;
  public cmsPutUser2(
    user_id: number,
    body?: CmsEditingUser,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingUser>>;
  public cmsPutUser2(
    user_id: number,
    body?: CmsEditingUser,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingUser>>;
  public cmsPutUser2(
    user_id: number,
    body?: CmsEditingUser,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (user_id === null || user_id === undefined) {
      throw new Error(
        'Required parameter user_id was null or undefined when calling cmsPutUser2.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<CmsEditingUser>(
      'put',
      `${this.basePath}/cms/user/${encodeURIComponent(String(user_id))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Restore a deleted user
   * @param user_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cmsRestoreUser2(
    user_id: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CmsEditingUser>;
  public cmsRestoreUser2(
    user_id: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CmsEditingUser>>;
  public cmsRestoreUser2(
    user_id: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CmsEditingUser>>;
  public cmsRestoreUser2(
    user_id: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (user_id === null || user_id === undefined) {
      throw new Error(
        'Required parameter user_id was null or undefined when calling cmsRestoreUser2.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<CmsEditingUser>(
      'post',
      `${this.basePath}/cms/user/restore/${encodeURIComponent(
        String(user_id)
      )}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
